import { Chip, ChipProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface StatusConfig {
  label: string;
  bgColor: string;
  color?: string;
}

interface OpenOrClosedProps extends Omit<ChipProps, 'label'> {
  status: string;
  statusKind: Record<string, StatusConfig>;
}

function OpenOrClosed({ status, statusKind, sx }: OpenOrClosedProps) {
  const theme = useTheme();
  const { t } = useTranslation('periods');

  const config = statusKind[status] || {
    label: status,
    bgColor: theme.palette.grey[600],
    color: 'white',
  };

  return (
    <Chip
      sx={{
        backgroundColor: config.bgColor,
        color: config.color ?? 'white',
        maxHeight: theme.spacing(3),
        width: theme.spacing(16),
        borderRadius: theme.spacing(0.6),
        ml: 1,
        fontWeight: 'bold',
        ...sx,
      }}
      label={t(config.label)}
    />
  );
}

export default OpenOrClosed;
